





export default {
  props: {
    name: {
      type: String,
      default: '',
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/markup/popup/form/dashed/component.vue